<div class="wa-wrapper">
  <div class="wa-teaser" *ngIf="showTeaser && !teaserDismissed">
    <button type="button" class="wa-teaser-close" (click)="dismissTeaser()" aria-label="Close">&times;</button>
    <a class="wa-teaser-text"
       href="https://wa.me/237681763523?text=Bonjour%20eFarm%20!"
       target="_blank"
       rel="noopener noreferrer">
      {{ 'whatsapp.teaser' | translate }}
    </a>
    <span class="wa-teaser-arrow"></span>
  </div>
  <div class="wa-blob-row">
    <span class="wa-tooltip">{{ 'whatsapp.tooltip' | translate }}</span>
    <a class="whatsapp-blob"
       href="https://wa.me/237681763523?text=Bonjour%20eFarm%20!"
       target="_blank"
       rel="noopener noreferrer"
       aria-label="Chat with us on WhatsApp">
      <i class="fab fa-whatsapp"></i>
    </a>
  </div>
</div>
